module.exports = __webpack_public_path__ + "img/frame (165).53d9b5dc.jpg";